// extracted by mini-css-extract-plugin
export default {"container":"Qp-z","ratingLayout":"Rp-z","ratingLabel":"Sp-z","nonInteractiveRatingLabel":"Tp-z"};